export const UUIDGenerator = (prefix = '') => {
  const stringToReturn = `${Math.random()
    .toString(36)
    .substring(2, 15)
    .toUpperCase()}`;
  return `${prefix}${
    prefix ? '-' : ''
  }${+new Date().valueOf()}-${stringToReturn}`;
};
